import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { wasHochsensibilitaetBedeutet } from './sections/was-hochsensibilitaet-bedeutet';
import { sensibilitaetUndVielseitigkeit } from './sections/sensibilitaet-und-vielseitigkeit';
import { psychologischeSicherheit } from './sections/psychologische-sicherheit';
import { herausforderungen } from './sections/herausforderungen';
import { strategien } from './sections/strategien';
import { faq } from './sections/faq';
import { referenzen } from './sections/referenzen';

export const content: BlogPostContent = {
  sections: [
    intro,
    wasHochsensibilitaetBedeutet,
    sensibilitaetUndVielseitigkeit,
    psychologischeSicherheit,
    herausforderungen,
    strategien,
    faq,
    referenzen
  ]
};
